import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { DndProvider } from 'react-dnd'; // Asegúrate de que esto esté importado
import { HTML5Backend } from 'react-dnd-html5-backend'; // y esto también

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      {/* El DndProvider debe envolver a App */}
      <DndProvider backend={HTML5Backend}> 
        <App />
      </DndProvider>
    </AuthProvider>
  </React.StrictMode>
);